import { string } from 'prop-types';

import { TypeChecker } from '@philips-emr/tws-core/lib/component/prop-types/util';
import { MessageService } from '@philips-emr/tws-core/lib/services';
import { Formatter, Validation } from '@philips-emr/tws-core/lib/services/model-service';

interface DomainFormatterOptions {
  domain?: string;
}

function format(value: string, options: DomainFormatterOptions = {}): string {
  return value ? MessageService.translate(`@beneficiary.${options.domain}/${value}`.toLowerCase()) : ``;
}

format.optionTypes = { domain: string } as unknown as Record<string, TypeChecker<any>>;

const DomainFormatter: Formatter<string> = {
  format,
  getPattern: (): string | RegExp => 'not implemented',
  parse: (value): string => value,
  validate: (): Validation[] => [],
};

export default DomainFormatter;
